import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../../auth/AuthContext";

export default function AccountLogin() {
  const { isAuthenticated, loading, signIn } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const redirect = searchParams.get("redirect") || "/pos-checkin";
  const [error, setError] = useState<string | null>(null);
  const signingIn = useRef(false);

  useEffect(() => {
    if (loading) return;
    if (isAuthenticated) {
      navigate(redirect, { replace: true });
      return;
    }
    if (signingIn.current) return;
    signingIn.current = true;
    // If we just logged out, force the IDP to show the login form instead of
    // silently re-authenticating via its still-active session cookie.
    const postLogout = sessionStorage.getItem("post_logout") === "1";
    if (postLogout) sessionStorage.removeItem("post_logout");
    signIn(redirect, postLogout ? "login" : undefined).catch((err: unknown) => {
      signingIn.current = false;
      const msg = err instanceof Error ? err.message : String(err);
      console.error("signIn failed:", err);
      setError(msg || "Failed to redirect to login. Please try again.");
    });
  }, [isAuthenticated, loading, navigate, redirect, signIn]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-gray-600">
        <p className="text-red-600 font-medium">Login error: {error}</p>
        <button
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          onClick={() => { signingIn.current = false; setError(null); signIn(redirect).catch(console.error); }}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center text-gray-600">
      Redirecting to Biznify login...
    </div>
  );
}
